import { EMPTY_STATE_VARIANTS } from 'ui/emptyState/EmptyState.types';
import { ErrorStatePageError, ZeroStateList } from 'ui/illustrations';
import { Spinner } from 'ui/spinner';
import { useDataQueryContext } from '../../contexts/DataQueryContext';
import { StyledEmptyState } from '../DataWarehousePage.styled';
import { Sources } from './Sources';

export const SOURCE_LIST_TEXT = {
  emptyStateSubtitle: 'Get started by connecting a new data source.',
  emptyStateTitle: 'No data syncs yet',
  errorStateSubtitle: 'Sorry about that!',
  errorStateTitle: "We're having trouble loading your data sync right now",
};

export const SourcesList = () => {
  const { isError, isLoading, syncs } = useDataQueryContext();

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return (
      <StyledEmptyState
        Illustration={ErrorStatePageError}
        subtitle={SOURCE_LIST_TEXT.errorStateSubtitle}
        title={SOURCE_LIST_TEXT.errorStateTitle}
        variant={EMPTY_STATE_VARIANTS.WITH_BORDERED_CONTAINER}
      />
    );
  }

  if (syncs.length < 1) {
    return (
      <StyledEmptyState
        Illustration={ZeroStateList}
        subtitle={SOURCE_LIST_TEXT.emptyStateSubtitle}
        title={SOURCE_LIST_TEXT.emptyStateTitle}
        variant={EMPTY_STATE_VARIANTS.WITH_BORDERED_CONTAINER}
      />
    );
  }

  return <Sources sources={syncs} />;
};
